import { IonItem } from '@ionic/react';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProductForm } from '../../../../api/hooks/products/useProductForm';
import { TEST_IDS } from '../../../../config/utils/constants';
import { TitleInList } from '../../../atoms/TitleInList';

interface Props {
  formik: any;
  index: number;
  isDisabled?: boolean;
}

export const DocProductUnit = ({ formik, index, isDisabled = false }: Props) => {
  const { t } = useTranslation();
  const { data } = useProductForm();

  const options = useMemo(
    () =>
      (data?.units || []).map((unit) => ({
        label: t(`PRODUCT_UNITS.${unit.name}`),
        value: unit.name,
      })),
    [data?.units, t],
  );

  const onChange = (value: string) => {
    const selectedUnit = (data?.units || []).find((u) => u.name === value);
    formik.setFieldValue(`products[${index}].unit`, value || null);
    formik.setFieldValue(`products[${index}].unitId`, selectedUnit?.id ?? null);
  };

  return (
    <div>
      <TitleInList index={index}>
        <div className="padding-b-16 padding-l-12">{t('SALE.UNIT')}</div>
      </TitleInList>
      <IonItem
        id={`product_unit_${index}`}
        className="width-300px height-50px border-radius-input g-select-border cursorPointer"
        mode="md">
        <Select
          id={`${TEST_IDS.Invoice.productUnitPicker}_${index + 1}`}
          allowClear
          showSearch
          disabled={isDisabled}
          placeholder={t('SALE.UNIT') + '...'}
          optionFilterProp="label"
          className="my-ant-select normalText5"
          variant="borderless"
          onChange={onChange}
          value={formik.values?.products[index]?.unit || null}
          options={options}
        />
      </IonItem>
    </div>
  );
};
